/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close[_ngcontent-%COMP%]{position:absolute;right:0;top:0;width:50px;height:60px}.close[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{color:#fff}.unread[_ngcontent-%COMP%]{font-weight:700;background-color:#f3f3f3}.list-padding[_ngcontent-%COMP%]{padding:1rem;border-bottom:1px solid #d3d3d3}"];
export { styles as styles };
